<template>
  <section id="work" class="cr-section about-area section-padding-sm bg-image-4" >

    <div class="container">
      <h2 >{{$t('Hogyan dolgozunk?')}}</h2>
      <div class="row align-items-start align-items-xl-center">
        <div class="col-md-6">
        <div class="testimonial text-center">
          <span class="testimonial-image">1.</span>
          <p>{{$t('Hogyan Ajánlat kérésnél minél részletesebben írd meg nekünk, hogy mit szeretnél, mik az elképzeléseid, ötleteid, elvárásaid. 24 órán belül küldjük is az árajánlatunkat!?')}}
            </p>
          <h5>{{$t('Ajánlat kérés')}}</h5>
          <span class="testimonial-border-topleft"></span>
          <span class="testimonial-border-topright"></span>
          <span class="testimonial-border-bottomleft"></span>
          <span class="testimonial-border-bottomright"></span>
        </div>
          </div>
        <div class="col-md-6">
          <div class="testimonial text-center">
          <span class="testimonial-image">2.</span>
          <p>{{$t('Amennyiben ajánlatunk elnyeri tetszésed, egy személyes találkozó keretében megbeszéljük a felmerülő kérdéseket, és egyeztetünk minden apró részletet.')}}</p>
          <h5>{{$t('Időpont egyeztetés')}}</h5>
          <span class="testimonial-border-topleft"></span>
          <span class="testimonial-border-topright"></span>
          <span class="testimonial-border-bottomleft"></span>
          <span class="testimonial-border-bottomright"></span>
        </div>
       </div>
      </div>
        <div class="row align-items-start align-items-xl-center">
          <div class="col-md-6">
            <div class="testimonial text-center">
              <span class="testimonial-image">3.</span>
              <p>{{$t('Elkészítjük a képeket, melyeket több helyen biztonságosan tárolunk majd. Határidőn belül elvégezzük a képek válogatását, és részletes, gondos utómunkáját.')}}</p>
              <h5>{{$t('Fotózás')}}</h5>
              <span class="testimonial-border-topleft"></span>
              <span class="testimonial-border-topright"></span>
              <span class="testimonial-border-bottomleft"></span>
              <span class="testimonial-border-bottomright"></span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="testimonial text-center">
              <span class="testimonial-image">4.</span>
              <p>{{$t('A képek az előre egyeztetett határidőn belül mindenképp átadásra kerülnek privát webgalériában, így megrendelőink könnyedén megoszthatják képeiket azokkal akikkel szeretnék. A galériákat egyedi jelszóval látjuk el.')}}</p>
              <h5>{{$t('Képek átadása?')}}</h5>
              <span class="testimonial-border-topleft"></span>
              <span class="testimonial-border-topright"></span>
              <span class="testimonial-border-bottomleft"></span>
              <span class="testimonial-border-bottomright"></span>
            </div>
          </div>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  name: 'Testimonal'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Testimonal.vue